
/* -------------------------------------

	Misc

------------------------------------- */

$(document).ready(function() {


	/* lazy load */
	$('img.lazy').lazyload({

		effect : 'fadeIn'

	});


	/* show more */
	$('.show-more').truncate({  
        max_length: 260,
        more: 'Show More',
        less: 'Show Less'
    });
	

});


$(window).load(function() {


	setTimeout(function() {

		$('html.js').addClass('load');

		/* animation */
		$('html.js .slidein').delay(75).animate({

			'padding-top': '0px'

		});

	}, 125);


});

